import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('booking');
const GET_BOOKING = define('GET_BOOKING', true);

const initialState = {
  data: [],
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BOOKING.PENDING:
      return {
        loading: true,
        data: [],
      };
    case GET_BOOKING.RESOLVED:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case GET_BOOKING.REJECTED: {
      return {
        ...state,
        loading: false,
      };
    }
    default: return state;
  }
}

export const actions = {
  loadBooking: (from, to) => ({
    type: GET_BOOKING,
    promise: api.get(`/affiliate/transactions?from=${from}&to=${to}`)
  })
}


// WEBPACK FOOTER //
// ./src/ducks/booking.js